import { bharatSportsbookApi } from "../api/gap.api";
import { gameApi } from "../api/game.api";
import { homeApi } from "../../home/api/home.api";
import { CheckGameAvailabilityRequest } from "../models/requests/CheckGameAvailabilityRequest";
import { CheckGameMaintenanceRequest } from "../models/requests/CheckGameMaintenanceRequest";
import { toastService as toast } from "../../../components/ui/toast/toast.service";
import common from "../../../utils/common";
import { SHOW_MAINTENANCE_EVENT } from "../../../components/ui/modals/GameMaintenanceModal";
import errorModal from "../../../services/errorModal.service";
import { AccessMode } from "../../../models/constants/accessMode";
import { ExchangeWindowClose } from "../../../assets/js/common";
import { commonService } from "../../../services/common.service";
import { localStorageService } from "../../../services";

export async function launchGapGame(
  providerName: string,
  gameId: string,
  accessModeSource: string
): Promise<any> {
  // 1. Check game availability
  const checkGameAvailabilityRequest: CheckGameAvailabilityRequest = {
    flag: "Vertical",
    gameId: "Sports",
  };

  const checkGameAvailability = await gameApi.checkGameAvailability(
    checkGameAvailabilityRequest,
  );
  if (
    checkGameAvailability.isSuccess &&
    checkGameAvailability.data &&
    !checkGameAvailability.data?.messagetype
  ) {
    const errorModal = document.getElementById("bharat-sportsbook-error-modal");
    const paragraph = errorModal?.getElementsByTagName("p")[0];
    if (paragraph) {
      paragraph.textContent = checkGameAvailability.data?.message;
    }
    errorModal?.classList.remove("hidden");
    return;
  }

  //2. Select Vertical

  const verticalsResponse = await homeApi.fetchActiveVerticals();
  if (!verticalsResponse.isSuccess) {
    window.location.href = "/";
    return;
  }

  const sportsVertical = verticalsResponse.data?.details.find(
    (v) => v.name === "Sports",
  );

  if (!sportsVertical) {
    throw new Error("Sports vertical not found");
  }

  //3. Fetch Game Providers

  const gameProvidersResponse = await gameApi.fetchGameProviders();
  if (!gameProvidersResponse.isSuccess) {
    window.location.href = "/";
    return;
  }
  const sapProvider = gameProvidersResponse.data?.details.find(
    (v) => v.name === "SAP",
  );
  if (!sapProvider) {
    throw new Error("SAP provider not found");
  }

  const verticalId = sportsVertical.id;
  const providerId = sapProvider.id;

  //4. Check game availability
  const checkGameMaintenanceRequest: CheckGameMaintenanceRequest = {
    verticalId,
    providerId,
  };

  const checkGameMaintenance = await gameApi.checkGameMaintenance(
    checkGameMaintenanceRequest,
  );

  if (!checkGameMaintenance.isSuccess) {
    toast.error(
      checkGameMaintenance.message || "Failed to check game maintenance.",
    );
    return;
  }

  if (
    checkGameMaintenance.isSuccess &&
    checkGameMaintenance.data?.message?.trim() &&
    checkGameMaintenance.data?.fromdate &&
    checkGameMaintenance.data?.todate
  ) {
    window.dispatchEvent(
      new CustomEvent(SHOW_MAINTENANCE_EVENT, {
        detail: {
          message: checkGameMaintenance.data.message,
          toDate: checkGameMaintenance.data.todate,
        },
      }),
    );
    return;
  }

  const data = checkGameMaintenance.data;

  if (
    data &&
    data.message &&
    data.message.trim() !== "" &&
    data.fromdate &&
    data.todate
  ) {
    const errorModal = document.getElementById("bharat-sportsbook-error-modal");
    const paragraph = errorModal?.querySelector("p");

    if (paragraph) {
      paragraph.textContent = data.message;
    }

    errorModal?.classList.remove("hidden");
    return;
  }

  // 5. Launch game
  const fetchCommonConfigResponse = await commonService.fetchCommonConfig();
  const deviceType = common.detectDeviceType();
  const userId = localStorageService.getItem<string>("userId")!;
  const username = localStorageService.getItem<string>("username")!;
  const ipAddress = fetchCommonConfigResponse.data?.ip!;

  const balanceResponse = await homeApi.fetchUserBalance();
  if (!balanceResponse.isSuccess) {
    errorModal.showErrorModal(balanceResponse.statusCode, balanceResponse.message, false);
    return;
  }

  const result = await bharatSportsbookApi.gapGameLaunch({
    userId,
    providerName: providerName,
    platformId: deviceType === "desktop" ? "desktop" : "mobile",
    clientIp: ipAddress,
    username,
    lobby: false,
    gameId: gameId,
    balance: balanceResponse.data?.mainWalletAmount!,
    redirectUrl: window.location.origin,
    accessMode: accessModeSource.toLowerCase() === AccessMode.App.toLowerCase() ? 2 : 1,
  });

  if (result.isSuccess) {
    await transferFundFromExchange();
    if (providerName !== "SAP" && result.data?.url) {
      localStorageService.setItem("gameUrl", result.data?.url);
    }
    return result.data?.url;
  } else {
    errorModal.showErrorModal(result.statusCode, result.message);
  }
}

async function transferFundFromExchange() {
  const balanceResponse = await homeApi.fetchUserBalance();
  if (balanceResponse.isSuccess) {
    if (
      balanceResponse.data?.is9WOn ||
      (balanceResponse.data?.exchangeBalance &&
        balanceResponse.data?.exchangeBalance > 0)
    ) {
      const transferFund = await gameApi.transferFundFromExchange();
      if (!transferFund.isSuccess) {
        errorModal.showErrorModal(transferFund.statusCode, transferFund.message, false);
      }
      else{
        await ExchangeWindowClose();
      }
    }
  }
}
